// 新聞元件 loading

const NewsSkeltonComponent = () => {
  return (
    <div className="flex-shrink-0 space-y-[20px] skelton-all">
      <div className="aspect-[368/233] w-full" />
      <div className="w-[124px] h-[17px]" />
      <div className="w-full h-[66px]" />
      <div className="w-full h-[59px]" />
    </div>
  );
};

export default NewsSkeltonComponent;
